import TYPE from "../../constants/type";
import { apiCall } from "../../utils/api";
import { notification } from "../home/action";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";

export const getSystemById = (id) => async (dispatch) => {
  const api = API_URLS.SYSTEM.getSystemById(id);
  dispatch({
    type: TYPE.SYSTEM.GET_SYSTEM_BY_ID_LOADING,
    meta: { prefix: [PREFIX.SYSTEM, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.SYSTEM.GET_SYSTEM_BY_ID_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.SYSTEM, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.SYSTEM.GET_SYSTEM_BY_ID_FAILURE,
      meta: { prefix: [PREFIX.SYSTEM, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      })
    );
  }
};

export const updateSystem = (id, payload) => async (dispatch) => {
  const api = API_URLS.SYSTEM.updateSystem(id);
  dispatch({
    type: TYPE.SYSTEM.UPDATE_SYSTEM_LOADING,
    meta: { prefix: [PREFIX.SYSTEM, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.SYSTEM.UPDATE_SYSTEM_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.SYSTEM, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Cập nhật thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.SYSTEM.UPDATE_SYSTEM_FAILURE,
      meta: { prefix: [PREFIX.SYSTEM, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Cập nhật thất bại!",
      })
    );
    return false;
  }
};

